import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';

import { Job} from '../../models/job';
import { Store } from '@ngrx/store';
import { AppState,selectReportState } from '@app/store/app.states';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { UpdateDocumentSegment } from '@app/store/actions/documentSegment.actions';
import { ReportTypes } from '../../models/report';
import { DocumentSegment } from '../../models/documentSegment';
import { PageBackground } from '../../models/pageBackground';
import { Project } from '../../models/project';

@Component({
  selector: 'app-apply-background-dialog',
  templateUrl: './apply-background-dialog.component.html',
  styleUrls: ['./apply-background-dialog.component.scss']
})
export class ApplyBackgroundDialogComponent implements OnInit {

  jobs:Job[];
  filteredPageBackgrounds:PageBackground[] = [];
  filteredBrandsPageBackgrounds:any[] = [];
  documentSegments:DocumentSegment[];
  project:Project;
  selectedJob:Job;
  selectedDocumentSegment:DocumentSegment;
  pageBackgrounds:PageBackground[];
  templateSet:PageBackground;

  constructor(
    public dialogRef: MatDialogRef<ApplyBackgroundDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private document: any,
    private fb: FormBuilder,
    private store: Store<AppState>
  ) { 
    this.jobs = data.jobs;
    this.selectedJob = data.job;
    this.selectedDocumentSegment = data.documentSegment?data.documentSegment:null
    this.documentSegments = data.documentSegments?data.documentSegments:null;
    this.pageBackgrounds = data.pageBackground;
    this.project = data.project;
    this.filteredBrandsPageBackgrounds = [];

    // this.filterPageBackgrounds(null);

    if(this.documentSegments)
      this.selectedJob = this.jobs[0];

    for (let i = 0; i < this.pageBackgrounds.length; i++) {
      if( this.project.businessBrandTag === this.pageBackgrounds[i].businessBrandTag || this.project.businessBrandTag === null) {
        let filteredBrands = this.pageBackgrounds[i];
        this.filteredBrandsPageBackgrounds.push(filteredBrands);
      }
    }

    this.filteredPageBackgrounds = this.filteredBrandsPageBackgrounds;
    
  }

  ngOnInit() {
  }

  getModalTitle():string{
    let title = "";

    if(this.selectedDocumentSegment){
      title = `${this.selectedDocumentSegment.segmentIdentifier} ${this.selectedDocumentSegment.segmentNumber}`;
    }else if(this.documentSegments){
      // group report
      let segment = this.documentSegments[0];
      title = `${segment.segmentIdentifier} ${segment.segmentNumber} for all Regions`;
    }else{
      // job report
      title = `Region ${this.selectedJob.campaignRegions[0].name}`;
    }

    return title;
  }

  filterPageBackgrounds(val:any):void{
    this.filteredPageBackgrounds = this.filteredBrandsPageBackgrounds.filter((bg) => val?bg.pageGroup == val.pageGroup:true);
  }

  onSubmit():void{
    let dsUUID = [];
    for(let job of this.jobs){
      for(let docs of job.documentSegments){
        if (this.documentSegments[0].segmentNumber === docs.segmentNumber) {
          let pagesUUID = docs.uuid;
          dsUUID.push(pagesUUID);
        }
      }
    }

    let joinUUID = dsUUID.join();
    let ds:DocumentSegment = new DocumentSegment();
    ds.uuid = joinUUID;
    ds.pageBackground = this.templateSet.id.toString();

    const payload = {documentSegment:ds};
    this.store.dispatch(new UpdateDocumentSegment(payload));

  }

  close():void{

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/apply-background-dialog/apply-background-dialog.component.ts